import type { ExcelAction } from "./types";
import { scanNamedRanges } from "../../namedRanges/scanner";
import { openNamedRangesDialog } from "../dialog-host";

export const listNamedRanges: ExcelAction = {
  id: "list-named-ranges",
  label: "List named ranges",
  description:
    "Scan every named range in the workbook (workbook- and sheet-scoped); show in a searchable, sortable dialog. Click any range-type row to navigate to it.",
  async run({ log }) {
    log("scanning named ranges...");
    let items;
    try {
      items = await scanNamedRanges();
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`scan failed: ${message}`, "error");
      return;
    }

    const invalidCount = items.filter((i) => !i.isValid).length;
    log(
      `found ${items.length.toLocaleString()} named range(s)` +
        (invalidCount > 0 ? `, ${invalidCount.toLocaleString()} with broken references` : ""),
      items.length > 0 ? "success" : "info",
    );

    try {
      await openNamedRangesDialog(items);
    } catch (err) {
      const message = err instanceof Error ? err.message : String(err);
      log(`dialog failed: ${message}`, "error");
    }
  },
};
